import { useEffect, useState } from "react";
import "./Countdown.css";

function Countdown({ targetDate }) {
    const [timeLeft, setTimeLeft] = useState({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
    });

    useEffect(() => {
        const calculateTimeLeft = () => {
            const difference = new Date(targetDate) - new Date();
            if (difference <= 0) {
                return { days: 0, hours: 0, minutes: 0, seconds: 0 };
            }

            return {
                days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                minutes: Math.floor((difference / (1000 * 60)) % 60),
                seconds: Math.floor((difference / 1000) % 60),
            };
        };

        setTimeLeft(calculateTimeLeft());

        const timer = setInterval(() => {
            setTimeLeft(calculateTimeLeft());
        }, 1000);

        return () => clearInterval(timer);
    }, [targetDate]);

    return (
        <div className="countdown-container">
            {Object.entries(timeLeft).map(([unit, value]) => (
                <div key={unit} className="countdown-box">
                    <div className="home-main-text">{String(value).padStart(2, "0")}</div>
                    <div className="home-text">
                        {unit === "days" && (value === 1 ? "Dag" : "Dagar")}
                        {unit === "hours" && (value === 1 ? "Timme" : "Timmar")}
                        {unit === "minutes" && (value === 1 ? "Minut" : "Minuter")}
                        {unit === "seconds" && (value === 1 ? "Sekund" : "Sekunder")}
                    </div>
                </div>
            ))}
        </div>
    );
}

export default Countdown;
